/* Extracted 2026-10-13 from layout/theme.liquid (inline block 8) — SEO round 3 step 3, audit C1. Loaded at the same position, synchronously. Edit here; the Liquid file only references it. */
(function () {
          var faqByHandle = {
            'active-5-aha-1-bha-body-cleanser': [
              ['How often should I use it?', 'Start 2-3 times a week, then build slowly if your skin stays comfortable.'],
              ['What does it help with?', 'It targets stubborn KP, strawberry skin, rough texture and pore congestion.'],
              ['Do I need SPF?', 'Yes. Exfoliating acids can increase sun sensitivity, so use SPF on exposed skin.'],
              ['Will it dry out my skin?', 'It can feel strong if overused. Follow with a plain body lotion and reduce frequency if skin feels tight.'],
              ['Is it suitable for sensitive skin?', 'Patch-test first. Sensitive skin should start once a week.'],
              ['What if it is not for me?', 'Pause if irritation continues, then restart less often. COD is available and shipping is free over Rs.699.']
            ],
            'active-2-salicylic-acid-body-cleanser': [
              ['How often should I use it?', 'Start 3-4 times a week. Use daily only if your skin stays comfortable.'],
              ['What does it help with?', 'It helps with back, chest and shoulder breakouts, oily congestion and clogged pores.'],
              ['Do I need SPF?', 'Use SPF on exposed body areas, especially if you also use other actives.'],
              ['Will it dry out my skin?', 'It is built for acne-prone body skin, but reduce frequency if dryness appears.'],
              ['Is it suitable for sensitive skin?', 'Patch-test first and avoid using it on broken or freshly shaved skin.'],
              ['What if it is not for me?', 'If stinging or dryness continues, pause use and restart less often. COD is available and shipping is free over Rs.699.']
            ],
            'bacne-warrior-acne-fighting-body-spray': [
              ['How long does a bottle last?', 'With daily use on the affected areas, one 100ml bottle typically lasts 6-8 weeks.'],
              ['When is the best time to use it?', 'Mist it after showering or post-workout, once skin is clean and dry.'],
              ['Does it work on back, chest and shoulders?', 'Yes. The 360-degree mist is built to reach the back, chest, shoulders and neck.'],
              ['Will it dry out my skin?', 'It pairs salicylic acid with niacinamide, cica and aloe so daily body use stays comfortable.'],
              ['Is it suitable for daily use?', 'Yes, but patch-test first and reduce frequency if your skin feels dry or tight.'],
              ['What if it is not for me?', 'Pause if irritation continues and contact support. COD is available and shipping is free over Rs.699.']
            ]
          };

          function handleFromPath() {
            var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
            return match && match[1];
          }

          function repairFaq() {
            var items = faqByHandle[handleFromPath()];
            if (!items) return;
            var faq = document.querySelector('.faq');
            if (!faq) return;
            var text = faq.textContent || '';
            var isBadBodyCopy = text.indexOf('Key Benefits') !== -1 ||
              text.indexOf('Timeline') !== -1 ||
              text.indexOf('support if the product arrives damaged or incorrect') !== -1;
            if (!isBadBodyCopy) return;
            faq.innerHTML = items.map(function (item) {
              return '<div class="qa"><h3>' + item[0] + '</h3><p>' + item[1] + '</p></div>';
            }).join('');
          }

          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', repairFaq);
          } else {
            repairFaq();
          }
          setTimeout(repairFaq, 250);
          setTimeout(repairFaq, 1000);
        })();
